import { TranslatedProduct } from "../types";

export const productsLV: TranslatedProduct= {
    "Orange": "Apelsīns",
    "Watermelon": "Arbūzs",
    "Avocado": "Avokado",
    "Apricots": "Aprikozes",
    "Pineapple": "Ananass",
    "Apples": "Āboli",
    "Alica": "Aliča",
    "Pears": "Bumbieri",
    "Eggplant": "Baklažāns",
    "Grapes": "Vīnogas",
    "Grapefruit": "Greipfruts",
    "Kiwi": "Kivi",
    "Gooseberries": "Ērkšķogas",
    "Strawberry": "Zemenes",
    "Mango": "Mango",
    "Raspberries": "Avenes",
    "Blueberries": "Mellenes",
    "Plums": "Plūmes",
    "Lemon": "Citrons",
    "Mandarin": "Mandarīns",
    "Olives": "Olīves",
    "Peaches": "Persiki",
    "Raisins": "Rozīnes",
    "Figs (fresh)": "Vīģes (svaigas)",
    "Red currants": "Jāņogas",
    "Black currants": "Upenes",
    "Artichokes": "Artišoki",
    "Swede": "Kālis",
    "Zucchini": "Kabacis",
    "Cabbage": "Galviņkāposts",
    "Capers": "Kaperi",
    "Carrots": "Burkāni",
    "Ķiploks": "Ķiploks",
    "Gurķis": "Gurķis",
    "Paprika": "Paprika",
    "Kartupeļu ciete": "Kartupeļu ciete",
    "Kartupeļi": "Kartupeļi",
    "Sago": "Sago",
    "Tapioca": "Tapioka",
    "Corn": "Kukurūza",
    "Corn starch": "Kukurūzas ciete",
    "Butter": "Sviests",
    "Canola oil": "Rapšu eļļa",
    "Sunflower seeds": "Saulespuķu sēklas",
    "Sunflower oil": "Saulespuķu eļļa",
    "Walnuts": "Valrieksti",
    "Onion": "Sīpols",
    "Walnut oil": "Valriekstu eļļa",
    "Margarine": "Margarīns",
    "Bacon": "Speķis",
    "Sugar": "Cukurs",
    "Honey": "Medus",
    "Glucose-fructose syrup": "Glikozes-fruktozes sīrups",
    "Jam": "Ievārījums",
    "Berry syrup": "Ogu sīrups",
    "Cotton candy": "Cukurvate",
    "Sorbet": "Sorbēts",
    "Frozen juice": "Saldētā sula",
    "Apple juice": "Ābolu sula",
    "Coca Cola": "Coca Cola",
    "Coca Cola zero": "Coca Cola zero",
    "Pepsi": "Pepsi",
    "Milk": "Piens",
    "Yogurt": "Jogurts",
    "Pumpkin": "Ķirbis",
    "Radish": "Redīsi",
    "Beets": "Bietes",
    "Celery": "Selerijas",
    "Sweet cream": "Saldais krējums",
    "Cottage cheese": "Biezpiens",
    "Cheese": "Siers",
    "Yolk": "Olas dzeltenums",
    "Egg white": "Olas baltums",
    "Egg": "Ola",
    "Gelatin": "Želantīns",
    "Black peppers": "Melnie pipari",
    "Peppermint": "Piparmētra",
    "Red beans": "Sarkanās pupiņas",
    "Green peas": "Zaļie zirnīši",
    "Coconut milk": "Kokosriekstu piens",
    "Turnip": "Rācēnis",
    "Tofu": "Tofu",
    "Split peas": "Šķeltie zirņi",
    "Cornflakes": "Kukurūzas pārslas",
    "Chips": "Čipsi",
    "Brussels sprouts": "Briseles kāposti",
    "Cauliflower": "Ziedkāposti",
    "Broccoli": "Brokoļi",
    "Cooked spinach": "Vārīti spināti",
    "Spinach (fresh)": "Spināti (svaigi)",
    "Ice cream": "Saldējums",
    "Pasta": "Makaroni",
    "Sour cream": "Skābais krējums",
    "Milk chocolate": "Piena šokolāde",
    "Bread": "Maize",
    "Chicken": "Vistas gaļa",
    "Pork": "Cūkgaļa",
    "Sausage": "Desa",
    "Hot dogs": "Cīsiņi",
    "Lentil": "Lēcas",
    "Sardels": "Sardeles",
    "Fish fingers": "Zivju pirkstiņi",
    "Fishballs": "Zivju kotletes",
    "Chocolate cheese": "Biezpiena sieriņš",
    "Curd cream": "Biezpiena krēms",
    "Wheat flour": "Kviešu milti",
    "Cookies" : "Cepumi",
    "Oat flakes": "Auzu pārslas",
    "Cashews": "Indijas rieksti",
    "Almonds": "Mandeles",
    "Coconut yogurt": "Kokosriekstu jogurts",
    "Aspartame": "Aspartāms",
    "Acesulfame potassium": "Kālija acesulfāms",
    "Sorbitol": "Sorbitols",
    "Stevia": "Stēvija",
    "Instant potato porridge": "Ātri pagatavojamā kartupeļu biezputra",
    "Shrimps": "Garneles",
    "Beef": "Liellops",
    "Veal": "Teļa gaļa",
    "Smoked meat": "Kūpinātā gaļa",
    "Vegan jellies": "Vegānu želējkonfektes",
    "Jelly candies with gelatin": "Želejkonfektes ar želnatīnu sastāvā",
    "Dried apricots": "Žāvētās aprikozes",
    "Buckwheat": "Griķi",
    "Asparagus": "Sparģeļi",
};
